import { Route } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';
import { gamesTrialGuard } from 'src/app/modules/games/guards/games-trial.guard';

export const halfItLocalGameRoutes: Route[] = [
    {
        path: 'local-games/halve-it',
        canActivate: [],
        loadComponent: () =>
            import('./pages/half-it-new-game/half-it-new-game.component').then((c) => c.HalfItNewGameComponent),
    },
    {
        path: 'game/halve-it',
        data: {
            gameMode: 'halve_it' as GameMode,
        },
        canActivate: [gamesTrialGuard],
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/half-it-local-game-app/half-it-local-game-app.component').then(
                (c) => c.HalfItLocalGameAppComponent
            ),
    },
];

export const halfItVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/halve-it',
        canActivate: [],
        loadComponent: () =>
            import('./pages/half-it-new-game/half-it-new-game.component').then((c) => c.HalfItNewGameComponent),
    },
    {
        path: 'game/halve-it',
        data: {
            gameMode: 'halve_it' as GameMode,
        },
        canActivate: [gamesTrialGuard],
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/half-it-local-game-venue/half-it-local-game-venue.component').then(
                (c) => c.HalfItLocalGameVenueComponent
            ),
    },
];
